var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"vb__layout"},[_c('a-layout-content',[_c('div',{class:{
        [_vm.$style.container]: true,
        vb__layout__squaredBorders: false,
        vb__layout__cardsShadow: true,
        vb__layout__borderless: false,
        [_vm.$style.white]: false,
        [_vm.$style.gray]: true,
      },style:({
        backgroundImage: 'url(resources/images/comercio.png)',
        backgroundSize: '100%',
      })},[_c('div',{class:{
          [_vm.$style.topbar]: true,
          [_vm.$style.topbarGray]: false,
        }},[_c('div',{class:_vm.$style.logoContainer},[_c('a',{attrs:{"href":"javascript: void(0);"}},[_c('img',{attrs:{"src":"resources/images/logo.png"}})])])]),_c('div',{staticClass:"mb-3"},[_c('router-view')],1),_c('div',{staticClass:"mt-auto pb-5 pt-5"},[_c('div',{staticClass:"text-center"},[_c('b',[_vm._v("CCEAD © "+_vm._s(new Date().getFullYear()))])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }